import React from 'react';
import PropTypes from 'prop-types';
import { createGlobalStyle } from 'styled-components';
import DatePickerComponent from 'react-datepicker';
import { InputStyles } from '../Input';
import { TextInputStyles } from '../TextField';
import 'react-datepicker/dist/react-datepicker.css';

// Components
import { MaterialIcon } from '../MaterialIcon';

const DatePickerWrapperStyles = createGlobalStyle`
    .datePicker {
        width: 100% !important;
        .react-datepicker__input-container {
            display: block !important;
            ${InputStyles}
        }
        
        .react-datepicker__input-container input {
            width: 100%;
            ${TextInputStyles}
            cursor: pointer !important;
        }

        .react-datepicker-wrapper {
            width: 100% !important;
        }
    }
    .datePicker.datePicker--with-border .react-datepicker__input-container {
        border: 1px solid hsl(0,0%,80%) !important;
    }
    .datePicker.datePicker--xs {
        font-size: 0.7995rem;
        .react-datepicker__input-container input {
            padding: 0.455rem 8px;
        }
    }
    .date-picker-wrapper--with-right-icon input {
        padding-right: 32px !important;
    }
    .date-picker-wrapper--with-right-icon i {
        position: absolute;
        right: 6px;
        top: 50%;
        margin-top: -10px;
        pointer-events: none;
    }
`;

export const convertUTCToLocalDate = (date) => {
    if (!date) {
        return date;
    }
    date = new Date(date);
    date = new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
    return date;
};

export const convertLocalToUTCDate = (date) => {
    if (!date) {
        return date;
    }
    date = new Date(date);
    date = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
    return date;
};

export const convertDateToISOString = (date) => date.toISOString().replace('Z', '+00:00');

const CustomInput = React.forwardRef(({ value, onClick }, ref) => (
    <div className="date-picker-wrapper date-picker-wrapper--with-right-icon">
        <input type="text" value={value} onClick={onClick} ref={ref} readOnly />
        <MaterialIcon icon="calendar_month" intent="info" size={20} />
    </div>
));

CustomInput.displayName = 'CustomInput';

CustomInput.propTypes = {
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
    onClick: PropTypes.func
};

export const DatePicker = ({ selected, onChange, withBorder, withIcon, ...props }) => {
    const datePickerProps = withIcon
        ? {
              ...props,
              customInput: <CustomInput />
          }
        : props;

    return (
        <>
            <DatePickerComponent
                wrapperClassName={`datePicker${withBorder ? ' datePicker--with-border' : ''}${
                    props?.size ? ` datePicker--${props?.size}` : ''
                }`}
                selected={selected}
                onChange={onChange}
                popperPlacement="bottom"
                {...datePickerProps}
            />
            <DatePickerWrapperStyles />
        </>
    );
};

DatePicker.propTypes = {
    onChange: PropTypes.func,
    selected: PropTypes.instanceOf(Date),
    size: PropTypes.string,
    withBorder: PropTypes.bool,
    withIcon: PropTypes.bool
};

DatePicker.defaultProps = {
    onChange: () => null
};
